import {
  Box,
  Button,
  CircularProgress,
  Paper,
  Step,
  StepLabel,
  Stepper,
} from "@mui/material";
import { Fragment, useEffect, useState } from "react";
import { ValidatorForm } from "react-material-ui-form-validator";
import { useLocation, useNavigate } from "react-router-dom";
import style from "./Form.module.scss";
import PersonalData from "./PersonalData";
import SystemDataCollection from "./SystemDataCollection";
import SystemDataTreatment from "./SystemDataTreatment";
import { postData } from "../Services/postData";
import { enumUrl } from "../Utils/utils";
import Terms from "./Terms";
import moment from "moment";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { DropzoneArea } from "material-ui-dropzone";
import { getData } from "../Services/getData";

const steps = [
  "Încărcare document",
  "Date personale",
  "Date sistem individual - COLECTARE",
  "Date sistem individual - EPURARE",
];
const PERSON = {
  naturalPerson: "Persoana fizica",
  legalPerson: "Persoana juridica",
};

function Form() {
  const { state } = useLocation();
  const [loading, setLoading] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [textError, setTextError] = useState("");
  const [streets, setStreets] = useState(null);
  const [form, setForm] = useState({
    document: {},
    personalData: {},
    systemDataCollection: {},
    systemDataTreatment: {},
  });
  const notifyError = (message) => toast.error(message);
  const navigate = useNavigate();

  useEffect(() => {
    if (!streets) getStreets();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /**
   *
   */
  async function getStreets() {
    setLoading(true);
    await getData(enumUrl.streets)
      .then((response) => {
        if (
          (response.status === 200 || response.status === 201) &&
          response.data
        ) {
          let tableData = [];
          response.data.forEach((street, index) => {
            tableData.push({
              id: index,
              label: street.street,
            });
          });
          setStreets(tableData);
        }
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  }

  /**
   * next step
   */
  const handleNext = () => {
    if (Object.keys(form.document).length === 0) {
      setTextError("Vă rugăm încărcați documentul!");
    } else setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  /**
   * step back
   */
  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  /**
   *
   * @param {*} files
   */
  function handleChangeDropFile(files) {
    if (files.length > 0) {
      let newForm = Object.assign({}, form);
      newForm.document = files instanceof Array ? files[0] : files;
      setTextError("");
      setForm(newForm);
    }
  }
  /**
   *
   * @returns
   * information for each step
   */
  function getInformation() {
    switch (activeStep) {
      case 0:
        return (
          <div>
            <p className={style.personalDataTitle}>
              {state === PERSON.legalPerson
                ? "Încărcați o copie după certidicatul de înregistrare fiscală"
                : "Încărcați o copie după cartea de identitate"}
            </p>
            <DropzoneArea
              acceptedFiles={["image/*", ".pdf"]}
              dropzoneClass={style.dropzoneArea}
              maxFileSize={5000000}
              filesLimit={1}
              onChange={(files) => handleChangeDropFile(files)}
            />
            <p style={{ color: "red" }}>{textError}</p>
          </div>
        );
      case 1:
        return (
          <PersonalData
            person={state}
            form={form}
            setForm={setForm}
            streets={streets}
          />
        );
      case 2:
        return <SystemDataCollection form={form} setForm={setForm} />;
      case 3:
        return <SystemDataTreatment form={form} setForm={setForm} />;
      default:
        break;
    }
  }

  /**
   * submit form
   */
  async function handleSubmit() {
    setLoading(true);
    form.personalData.address.street = form.personalData.address.street.label
      ? form.personalData.address.street.label
      : form.personalData.address.street;
    form.personalData.buildingAddress.sc = form.personalData.buildingAddress.sc
      .label
      ? form.personalData.buildingAddress.sc.label
      : form.personalData.buildingAddress.sc;

    const formData = new FormData();
    formData.append("file", form.document);
    formData.append("person", state);
    formData.append("date", moment().format("YYYY-MM-DD"));
    formData.append(
      "token",
      localStorage.getItem("access_token")
        ? localStorage.getItem("access_token")
        : ""
    );
    formData.append("personalData", JSON.stringify(form.personalData));
    formData.append(
      "systemDataCollection",
      JSON.stringify(form.systemDataCollection)
    );
    formData.append(
      "systemDataTreatment",
      JSON.stringify(form.systemDataTreatment)
    );
    await postData(enumUrl.form, formData)
      .then(async (response) => {
        if (response.status === 200 || response.status === 201) {
          navigate("/confirm");
        } else {
          notifyError("Eroare");
        }
        setLoading(false);
      })
      .catch((err) => {
        notifyError("Eroare");
        setLoading(false);
      });
  }

  return (
    <div className={style.background}>
      <div>
        <h1 className={style.title}>
          FORMULAR DE ÎNSCRIERE în Registrul de Evidență al Sistemelor
          Individuale Adecvate pentru Colectarea și Epurarea Apelor Uzate al
          Municipiului Suceava
        </h1>
        <div className={style.container}>
          <Stepper activeStep={activeStep} className={style.stepper}>
            {steps.map((label, index) => {
              const stepProps = { completed: false };
              const labelProps = {
                optional: "",
              };

              return (
                <Step
                  key={label}
                  {...stepProps}
                  style={{ color: "white !important" }}
                >
                  <StepLabel
                    {...labelProps}
                    style={{ color: "white !important" }}
                  >
                    {label}
                  </StepLabel>
                </Step>
              );
            })}
          </Stepper>
          <Paper className={style.containerPaper}>
            {activeStep === steps.length ? (
              <Fragment>
                <Terms handleSubmit={handleSubmit} />
              </Fragment>
            ) : (
              <Fragment>
                <ValidatorForm onSubmit={handleNext}>
                  {getInformation()}
                  <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
                    <Button
                      variant="contained"
                      size="large"
                      disabled={activeStep === 0 || activeStep === 1}
                      onClick={handleBack}
                    >
                      Back
                    </Button>
                    <Box sx={{ flex: "1 1 auto" }} />
                    <Button variant="contained" type="submit" size="large">
                      Next
                    </Button>
                  </Box>
                </ValidatorForm>
              </Fragment>
            )}
          </Paper>
        </div>
      </div>
      {loading ? (
        <div className={style.loading}>
          <CircularProgress color="primary" />
        </div>
      ) : (
        ""
      )}
      <ToastContainer />
    </div>
  );
}

export default Form;
